"use client";

import { useEffect } from "react";

const SITE = "Nurse Tools";

/** Keep the browser tab title in sync after client data resolves (e.g. localStorage). */
export function useDocumentTitle(title: string | undefined | null) {
  useEffect(() => {
    if (!title) return;
    document.title = title === SITE ? SITE : `${title} · ${SITE}`;
  }, [title]);
}
